/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { updatePreferredPaymentType } from 'state/actions/accountState/account_data';
import { sendMessage } from '@insticator/insticator-ui'; // iui-state
// component
import PreferSelector from 'pages/dashboard/account/paymentinfo/enterinformation/preferselector/preferselector';



/* ========== ~~~~~~~~~~ ACCOUNT PREFER SELECTOR : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData }) => ({
    fields: accountData[accountData.selectedPaymentType].fields,
    savingData: accountData[accountData.selectedPaymentType].savingData,
    editable: accountData[accountData.selectedPaymentType].editable,
    hasStoredData: Object.keys(accountData[accountData.selectedPaymentType].storedData).length > 0,

    selectedPaymentType: accountData.selectedPaymentType,
    preferredPaymentType: accountData.preferredPaymentType
});

// map actions
const mapDispatchToProps = dispatch => ({
    updatePreferredPaymentType: paymentType => dispatch(updatePreferredPaymentType(paymentType)),
    sendMessage: (message) => dispatch(sendMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PreferSelector);
